import {HttpClient, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  AlterarSenhaCandidato,
  AutenticarCandidato,
  CadastrarCandidato,
  RecuperarSenhaCandidato,
  AlterarEmailCandidato,
  VerificarQuestoesSegurancaCandidato,
  SalvarInscricao,
  ExcluirRequisitoInscricao,
  IncluirRequisitoInscricao,
  ExcluirCurriculo,
  Curriculo,
  FinalizarInscricao,
  Indicador,
  Cidade,
  DadosCandidato,
  EditarDadosCandidatoCommand,
  UnidadesOperacional,
  UnidadesFederativas,
  FiltroVagaDisponiveis,
  VagaDisponivelCadastroReserva,
  RetornoPadrao,
  DadosBasicosRedacao
} from '@app/models/sisrh.model';
import { environment } from '@env/environment';
import { map } from 'rxjs/operators';
import { AceitarConviteCommand, RejeitarConviteCommand } from '@app/models/cadastroReserva';

@Injectable({
  providedIn: 'root'
})
export class SisrhService {

  constructor(private httpClient: HttpClient) { }

  existir(cpf: string): Observable<any> {
    return this.httpClient
      .get(`${environment.url_api_sisrh}/v1/candidato/existe/${cpf}`);
  }

  cadastrar(cadastrarCandidato: CadastrarCandidato): Observable<any> {
    return this.httpClient
      .post(`${environment.url_api_sisrh}/v1/candidato/cadastrar`, cadastrarCandidato);
  }

  editar(command: EditarDadosCandidatoCommand, token: string): Observable<any> {
    return this.httpClient.post(`${environment.url_api_sisrh}/v1/gerenciarcandidato/editarDados`,
      command,
      { 'headers': { 'Authorization': `Bearer ${token}`}});
  }

  dadosObrigatoriosPreenchidos(idCandidato: string): Observable<boolean> {
    return this.httpClient.get<boolean>(
      `${environment.url_api_sisrh}/v1/candidato/dados-obrigatorios-preenchidos/${idCandidato}`);
  }

  autenticar(autenticarCandidato: AutenticarCandidato): Observable<any> {
    return this.httpClient
      .post(`${environment.url_api_sisrh}/v1/candidato/autenticar`, autenticarCandidato);
  }

  recuperarSenha(recuperarSenhaCandidato: RecuperarSenhaCandidato): Observable<any> {
    return this.httpClient
      .post(`${environment.url_api_sisrh}/v1/candidato/recuperar-senha`, recuperarSenhaCandidato);
  }

  alterarSenha(alterarSenhaCandidato: AlterarSenhaCandidato): Observable<any> {
    return this.httpClient
      .post(`${environment.url_api_sisrh}/v1/candidato/alterar-senha`, alterarSenhaCandidato);
  }

  alterarEmail(alterarEmailCandidato: AlterarEmailCandidato): Observable<any> {
    return this.httpClient
      .post(`${environment.url_api_sisrh}/v1/candidato/alterar-email`, alterarEmailCandidato);
  }

  verificarQuestoesSeguranca(verificarQuestoesSegurancaCandidato: VerificarQuestoesSegurancaCandidato): Observable<any> {
    return this.httpClient
      .post(`${environment.url_api_sisrh}/v1/candidato/verificar-questoes-seguranca`, verificarQuestoesSegurancaCandidato);
  }

  processosSeletivosDisponiveis(): Observable<any> {
    return this.httpClient
      .get(`${environment.url_api_sisrh}/v1/processoDisponiveis`);
  }

  vagasDisponiveisPorCandidato(filtros: FiltroVagaDisponiveis): Observable<any> {
    return this.httpClient
      .post(`${environment.url_api_sisrh}/v1/inscricao/vagasDisponiveis`, filtros);
  }

  detalhesVaga(idVaga: string): Observable<any> {
    return this.httpClient
      .get(`${environment.url_api_sisrh}/v1/buscarVagaDetalhe/${idVaga}`)
      .pipe(map((x: any) => {
        const conhecimentos = x.requisitos.filter(c => c.tipo === '080d52e2-72ff-49f7-8455-bd96d00d39a5');
        const requisitosDesejaveis = x.requisitos.filter(rd => rd.tipo === 'cf4e5d78-b832-4357-8982-24809d20b6c1');
        const requisitosNecessarios = x.requisitos.filter(rn => rn.tipo === '54636bf2-e544-478d-a3ae-d1006922fb6c');
        return {
          ...x,
          conhecimentos,
          requisitosDesejaveis,
          requisitosNecessarios
        };
      }));
  }

  salvarInscricao(salvarInscricao: SalvarInscricao): Observable<any> {
    return this.httpClient
      .post(`${environment.url_api_sisrh}/v1/inscricao`, salvarInscricao);
  }

  detalheVagaPorInscricao(idInscricao: string): Observable<any> {
    return this.httpClient
      .get(`${environment.url_api_sisrh}/v1/detalheVagaInscricao/${idInscricao}`);
  }

  inscricaoRequisitoPorInscricao(idInscricao: string): Observable<any> {
    return this.httpClient
      .get(`${environment.url_api_sisrh}/v1/inscricao/inscricaoRequisito/${idInscricao}`);
  }

  finalizarInscricao(finalizarInscricao: FinalizarInscricao): Observable<any> {
    return this.httpClient
      .post(`${environment.url_api_sisrh}/v1/inscricao/finalizar`, finalizarInscricao);
  }

  preencherRespostas(respostas: any): Observable<any> {
    return this.httpClient
      .post(`${environment.url_api_sisrh}/v1/inscricaoPortal/respostas`, respostas);
  }

  incluirComprovante(incluirRequisitoInscricao: IncluirRequisitoInscricao) {

    const fdIncluirRequisitoInscricao = new FormData();
    fdIncluirRequisitoInscricao.append('idInscricao', incluirRequisitoInscricao.idInscricao);
    fdIncluirRequisitoInscricao.append('idVagaRequisito', incluirRequisitoInscricao.idVagaRequisito);
    fdIncluirRequisitoInscricao.append('comprovante', incluirRequisitoInscricao.comprovante);

    return this.httpClient
      .post(`${environment.url_api_sisrh}/v1/inscricaoPortal/comprovante`, fdIncluirRequisitoInscricao);

  }

  excluirComprovante(excluirRequisitoInscricao: ExcluirRequisitoInscricao) {
    return this.httpClient
      .post(`${environment.url_api_sisrh}/v1/inscricao/excluirRequisitoInscricao`, excluirRequisitoInscricao);
  }

  curriculo(opcao: string, idCandidato: string): Observable<any> {
    return this.httpClient
      .get(`${environment.url_api_sisrh}/v1/inscricao/curriculo/${opcao}/${idCandidato}`);
  }

  excluirCurriculo(excluirCurriculo: ExcluirCurriculo): Observable<any> {
    return this.httpClient.post(`${environment.url_api_sisrh}/v1/inscricao/excluir-curriculo`, excluirCurriculo);
  }

  salvarCurriculo(curriculo: Curriculo): Observable<any> {
    return this.httpClient.post(`${environment.url_api_sisrh}/v1/inscricao/cadastrar-curriculo`, curriculo);
  }

  baixarArquivos(idInscricaoRequisito: string): Observable<any> {
    return this.httpClient.get(`${environment.url_api_sisrh}/v1/inscricao/download/${idInscricaoRequisito}`, { responseType: 'blob' });
  }

  public BuscarDadosCandidatosVaga(idEntrevistaVaga: string): Observable<any> {
    const authHeader = new Headers();
    authHeader.append('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get(environment.url_api_sisrh + '/v1/BuscarDadosCandidatosVaga/' + idEntrevistaVaga);
  }

  public BuscarQuestoesEntrevistaVaga(idEntrevistaVaga: string): Observable<any> {
    const authHeader = new Headers();
    authHeader.append('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get(environment.url_api_sisrh + '/v1/BuscarQuestoesEntrevistaVaga/' + idEntrevistaVaga);
  }

  public BuscarIndicadoresPorIdTipo(idTipoIndicador: string): Observable<Indicador[]> {
    return this.httpClient.get<Indicador[]>(environment.url_api_sisrh + '/v1/Indicador/' + idTipoIndicador);
  }

  public BuscarCidadesPorUf(uf: string): Observable<Cidade[]> {
    return this.httpClient.get<Cidade[]>(environment.url_api_sisrh + '/v1/buscarCidades/' + uf);
  }

  public BuscarDadosCandidato(cpf: string, token: string): Observable<DadosCandidato> {
    return this.httpClient.get<DadosCandidato>(environment.url_api_sisrh + '/v1/gerenciarcandidato/buscar/' + cpf,
      { 'headers': { 'Authorization': `Bearer ${token}`}});
  }

  public BuscarUnidadesFederativas(): Observable<UnidadesFederativas[]> {
    return this.httpClient.get<UnidadesFederativas[]>(environment.url_api_sisrh + '/v1/gerenciarcandidato/buscar/unidades-federativas');
  }

  public BuscarUnidadesOperacional(uf: string): Observable<UnidadesOperacional[]> {
    return this.httpClient.get<UnidadesOperacional[]>(environment.url_api_sisrh + '/v1/gerenciarcandidato/buscar/unidades-operacional/' + uf);
  }

  public BuscarVagasDisponiveisCadastroReserva(filtros: FiltroVagaDisponiveis): Observable<VagaDisponivelCadastroReserva[]> {
    return this.httpClient.post<VagaDisponivelCadastroReserva[]>(environment.url_api_sisrh + '/v1/inscricao/vagasDisponiveisCadastroReserva',
      filtros);
  }

  public AceitarConviteCadastroReserva(command: AceitarConviteCommand): Observable<RetornoPadrao> {
    return this.httpClient.post<RetornoPadrao>(environment.url_api_sisrh + '/v1/cadastro-reserva/aceitar-convite', command);
  }

  public RejeitarConviteCadastroReserva(command: RejeitarConviteCommand): Observable<RetornoPadrao> {
    return this.httpClient.post<RetornoPadrao>(environment.url_api_sisrh + '/v1/cadastro-reserva/rejeitar-convite', command);
  }

  public BuscarDadosBasicosRedacaoPorInscricao(idInscricao: string): Observable<DadosBasicosRedacao> {
    return this.httpClient.get<DadosBasicosRedacao>(environment.url_api_sisrh + '/v1/redacao/dados-basicos-por-inscricao/' + idInscricao);
  }
}
